import { addMinutes, addHours, isPast } from 'date-fns';

const isPastMeeting = meeting => {
  if (typeof meeting.endedAt !== 'undefined') {
    return true;
  }

  if (meeting.scheduledEndedAt) {
    if (!isPast(new Date(meeting.scheduledEndedAt))) {
      return false;
    }

    return true;
  }

  if (!meeting.establishedAt && isPast(addHours(new Date(meeting.scheduledAt), 1))) {
    return true;
  }

  if (meeting.lastTouchedAt && isPast(addMinutes(new Date(meeting.lastTouchedAt), 10))) {
    return true;
  }

  return false;
};

export default isPastMeeting;
